import { M } from '@strength/loco-sync';
import { inArray } from '@teamworksdev/loco-sync-client';
import { useMemo } from 'react';
import { useQuery } from '../../../../loco-sync';
import { Block } from '../timeline/types';
import { BlockType } from '@strength/domain';

export type TimelineSyncData = {
  blocks: Block[];
  focuses: M['TrainingFocus'][] | undefined;
  athleteTransferredTracks: M['AthleteTransferredTrack'][] | undefined;
};

export function useTimelineSync(
  trackIds: string[],
  showCanceled: boolean,
  blockTypeFilter: BlockType[],
): TimelineSyncData {
  const { data: blocksWithFocuses } = useQuery(
    'Block',
    {
      trackId: inArray(trackIds ?? []),
      ...(showCanceled ? {} : { status: 'planned' }),
      // filter by block types if provided
      ...(blockTypeFilter.length > 0
        ? { blockType: inArray(blockTypeFilter) }
        : {}),
    },
    {
      focuses: {
        focus: true,
      },
      transferredAthletes: true,
    },
  );

  const { data: athleteTransferredTracks } = useQuery(
    'AthleteTransferredTrack',
    {
      trackId: inArray(trackIds ?? []),
    },
  );

  const { data: focuses } = useQuery('TrainingFocus');

  const blocks = useMemo(() => {
    if (!blocksWithFocuses) return [];
    return blocksWithFocuses.map((block) => ({
      ...block,
      focuses: block.focuses.flatMap((f) => {
        if (!f.focus) return [];
        return [
          {
            id: f.id,
            focusId: f.focusId,
            focus: f.focus,
          },
        ];
      }),
    }));
  }, [blocksWithFocuses]);

  return {
    blocks,
    focuses,
    athleteTransferredTracks,
  };
}
